import { Center } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import EditIcon from '@/common/assets/icons/editIcon.svg?react';

const EditSign = ({ onClick }: { onClick: () => void }) => {
  return (
    <Center
      onClick={onClick}
      borderBottomRadius="8px"
      bgColor={'purple-6'}
      h="40px"
      width="100%"
    >
      <Typography textStyle="b2" display="flex" gap="8px" alignItems="center">
        <EditIcon />
        ویرایش امضا
      </Typography>
    </Center>
  );
};

export default EditSign;
